import axios from 'axios'
import config from '../../config'

export default {
  massImportHeartRate() {
    return axios.get(config.apiUrl + 'integration/striiv/massimport/heartrate');
  }
}



// WEBPACK FOOTER //
// ./src/api/Striiv/index.js